
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.203 14.346"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_32379","data-name":"Path 32379","d":"M10.092.981A1.555 1.555 0 0111.45 2.54v11.055L6.102 10.92.75 13.595V2.54A1.554 1.554 0 012.111.981a34.612 34.612 0 017.982 0z","fill":"none","stroke":"#6964eb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    